import { render, staticRenderFns } from "./Omalizumabe75Warning.vue?vue&type=template&id=a44c1b36&"
import script from "./Omalizumabe75Warning.vue?vue&type=script&lang=js&"
export * from "./Omalizumabe75Warning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports